// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function Toggle(Props) {
  let checked = Props.checked;
  let onChange = Props.onChange;
  return JsxRuntime.jsx("span", {
    children: JsxRuntime.jsx("span", {
      "aria-hidden": true,
      className: Cn.fromList({
        hd: "inline-block h-4 w-4 rounded-full bg-white transition ease-in-out duration-200",
        tl: {
          hd: Cn.on("translate-x-0", !checked),
          tl: {
            hd: Cn.on("translate-x-[14px]", checked),
            tl: /* [] */ 0
          }
        }
      })
    }),
    className: Cn.fromList({
      hd: "relative inline-flex shrink-0 h-[18px] w-8 border border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden",
      tl: {
        hd: Cn.on("bg-default-gray", !checked),
        tl: {
          hd: Cn.on("bg-primary", checked),
          tl: /* [] */ 0
        }
      }
    }),
    role: "checkbox",
    tabIndex: 0,
    onClick: (function (param) {
      Curry._1(onChange, !checked);
    })
  });
}

const make = Toggle;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
